import React from 'react';

import './PartnersTop.scss';

class PartnersTop extends React.PureComponent {
  render() {

    return (
      <section className="partnersTop">
        <div className="container">
          <h2 className="line text-center">Partneři</h2>
          <h4 className="text-center">
            Představujeme Vám několik lékařů, salónů krásy a center, která s námi dlouhodobě spolupracují <br/>
            tak, aby spokojenost byla především na straně klienta...
          </h4>
        </div>
      </section>
    );

  }
}

export default PartnersTop;



// WEBPACK FOOTER //
// ./src/components/Partners/PartnersTop/PartnersTop.js